const GAME_STATES = {
    matching: "MATCHING",
    placing_bombs: "PLACING_BOMBS",
    playing: "PLAYING",
    inactive: "INACTIVE",
    game_over: "GAME_OVER"
};

const RGBA = {
    light_yellow: "rgba(255, 235, 59, 0.5)",
    cyan: "rgba(0, 255, 195, 0.4)",
    soft_green: "rgba(76, 175, 80, 0.5)",
    light_blue: "rgba(33, 150, 243, 0.5)",
    iwc_purple: "rgba(196, 4, 244, 1)",
    soft_orange: "rgba(255, 87, 34, 0.5)",
    warm_peach: "rgba(255, 158, 120, 0.5)"
}

module.exports = { GAME_STATES, RGBA };